module.exports = __webpack_public_path__ + "static/media/popcorn-sad.5f00c4d3.png";